<template>
    <div class="new-business-type" v-if="dataForm.step == '01'">
        <!-- <ab-title title="选择产品" class="select-product"></ab-title> -->
        <ab-title title="选择报关服务" class="select-customs-clearance">
            <div class="content-box">
                <el-row :gutter="30">
                    <el-col :span="24" style="margin-bottom: 30px">
                        <div class="box-content">
                            <el-checkbox v-model="isImport" style="font-weight: 600; font-size;"> <b>进口服务</b> </el-checkbox>
                            <span @click="showDialog('Im')">业务介绍>></span>
                            <img :src=" require(`../../../assets/img/sign/contract/import-bgd.png`)">
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="box-content">
                            <el-checkbox v-model="isExport" style="font-weight: 600"> <b>出口服务</b> </el-checkbox>
                            <span @click="showDialog('Ex')">业务介绍>></span>
                            <img :src=" require(`../../../assets/img/sign/contract/export-bgd.png`)">
                        </div>
                    </el-col>
                </el-row>
            </div>
        </ab-title>
        <div class="footer">
            <el-button type="primary" :loading="isloading" @click="twoStep" :disabled="!isImport && !isExport">下一步</el-button>
            <el-button :loading="isloading" style="border-left: 1px solid #ccc" @click="backToStep">返回</el-button>
        </div>
        <el-dialog v-model="dialog.show" class="introduction-dialog" width="908px" :title="`${dialog.type == 'Im' ? '进口' : '出口'}业务介绍`" top="200px" append-to-body>
            <div><img :src=" require(`../../../assets/img/sign/contract/${dialog.type}port-introduction.png`)"></div>
            
            <span class="dialog-footer">
                <el-button @click="dialog.show = false"
                >取消</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isloading: false,
            isImport: false,
            isExport: false,
            dialog: {
                show: false,
                title: '进口业务介绍',
                type: 'Im'
            }
        }
    },
    props: {
        dataForm: {
            type: Object,
            defualt: {}
        }
    },
    methods: {
        backToStep () {
            this.isloading = true
            this.$router.push(
                {
                    path: '/signProtocol-list'
                }
            )
            this.isloading = false
        },
        showDialog(type) {
            this.dialog.type = type
            this.dialog.show = true
        },
        twoStep() {
            let str = this.isImport &&  this.isExport ? '01,02' : (this.isImport ? '01' : '02')
            this.isloading = true
            let data = Object.assign({}, this.dataForm, {step: '02', bizTypes: str})
            this.$parent.gotoStep(data).then(() => {}).finally(() => {
                this.isloading = false
            })
        },
    }
}
</script>
<style scoped lang="scss">
    .new-business-type{
        .select-customs-clearance{
            margin-top: 10px;
            .content-box{
                padding: 20px;
                position: relative;
                .box-content{
                    padding: 0 15px;
                    width: 818px;
                    position: relative;
                    left: 50%;
                    margin-left: -409px;
                    background-color: #f3f8fc;
                    height: 60px;
                    line-height: 60px;
                    font-size: 14px;
                    span{
                        cursor: pointer;
                        position: absolute;
                        right: 28px;
                        z-index: 222;
                    }
                    img{
                        position: absolute;
                        right: 24px;
                        z-index: 1;
                        top: 16px;
                    }
                }
            }
        }   
    }
</style>
<style lang="scss">
    .introduction-dialog{
        .el-dialog{
            overflow: hidden;
            .el-dialog__body{
                padding: 0 !important;
                padding-bottom: 10px;
                border-bottom: 1px solid #F3F8FC;
            }
            .dialog-footer{
                .el-button{
                    float: right;
                    height: 49px;
                    border-left: 1px solid #F3F8FC;
                    border-top: 1px solid #F3F8FC;
                }
            }
        }
    }
</style>